module.exports = __webpack_public_path__ + "static/nmcs-b44fe394d0ecb30ef536f127a538b7f2.jpg";